const ROOT = 'properties/owners/authorizations/'

export default {
	show: `${ROOT}`,
	update: `${ROOT}`
}
